import { render } from "./OfflineinspectionView.vue?vue&type=template&id=be049c52"
import script from "./OfflineinspectionView.vue?vue&type=script&lang=js"
export * from "./OfflineinspectionView.vue?vue&type=script&lang=js"

import "./OfflineinspectionView.vue?vue&type=style&index=0&id=be049c52&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__